import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError
} from "@reduxjs/toolkit/query";

import appConfig from "../../app.config";
import { SPAN_STATUS_ERROR, SPAN_STATUS_OK } from "@sentry/core";

export const transformResponse = (response: any): any => {
  response.ok = ['success', 'already_authenticated'].includes(response.code as string);
  response.sentrySpanStatus = {
    code: response.ok ? SPAN_STATUS_OK : SPAN_STATUS_ERROR,
    message: response.ok ? 'ok' : 'internal_error'
  };
  return response;
}

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const baseResult = await fetchBaseQuery({
    baseUrl: appConfig.apiBaseUrl,
    credentials: 'include'
  })(args, api, extraOptions);
  if(baseResult.data) {
    (baseResult.data as any).httpStatus = baseResult.meta?.response?.status;
  }

  return baseResult;
};
